// Local translations
export const T = {
  en_GB: {
    title: "Sumsub ID verification",
    description: "Choose how Sumsub identity verification runs for your organization",
    mode: "Mode",
    disabled: "Disabled",
    test: "Test",
    production: "Production",
    usingDisabled: "ID verification is turned off for your organization",
    usingTestCreds: "Using the shared sandbox environment",
    usingProdCreds: "Using the production environment",
    failedToSave: "Failed to save settings",
    settingsSaved: "Saved",
    pricesFootnote: "Prices apply to production usage only. Test mode is free.",
  },
  nb_NO: {
    title: "Sumsub ID-verifisering",
    description: "Velg hvordan Sumsub identitetsverifisering kjører for organisasjonen din",
    mode: "Modus",
    disabled: "Deaktivert",
    test: "Test",
    production: "Produksjon",
    usingDisabled: "ID-verifisering er slått av for organisasjonen din",
    usingTestCreds: "Bruker det delte sandkassemiljøet",
    usingProdCreds: "Bruker produksjonsmiljøet",
    failedToSave: "Kunne ikke lagre innstillinger",
    settingsSaved: "Lagret",
    pricesFootnote: "Priser gjelder kun produksjonsbruk. Testmodus er gratis.",
  },
} as const;
